export enum JoinableType {
    Project = 'project',
    Event = 'event',
}
